import { AFITD_ENV } from '../system/env';

export const getEnvVariable = name => {
    // const isDev = process.env.REACT_APP_ENV === 'DEV';
    const isTest = AFITD_ENV === 'TEST';
    const isStaging = AFITD_ENV === 'STAGING';
    const isProd = AFITD_ENV === 'PROD';

    switch (name) {
        case 'AFITD_NAME':
            return 'afootinthedoor';
        case 'AFITD_DOMAIN':
            return 'afootinthedoor.work';
        case 'AFITD_WWW_DOMAIN_URL':
            return isTest ? 'www.afootinthedoor.work' : isStaging || isProd ? 'www.afootinthedoor.work' : 'www.afootinthedoor.work';
        case 'AFITD_SHARE_URL':
            // 'abyss-vendor-b829d.web.app' // vendor
            return process.env.NODE_ENV === 'development'
                ? 'localhost:3000'
                : isTest
                ? 'afitd-test.web.app'
                : isStaging || isProd
                ? 'www.afootinthedoor.work'
                : 'www.afootinthedoor.work';
        case 'AFITD_COMPANY_INC_NAME':
            return 'A Foot in the Door, Inc.';
        case 'AFITD_SITE_NAME':
            return 'A Foot in the Door';
        case 'DYNAMIC_LINK_PREFIX':
            return process.env.NODE_ENV === 'development'
                ? 'https://afitdtest.page.link'
                : isTest
                ? 'https://afitdtest.page.link'
                : isStaging || isProd
                ? 'https://afootinthedoor.page.link'
                : 'https://afootinthedoor.page.link';
        case 'AFITD_JITSI_URL':
            return 'jitsi.afootinthedoor.work';
        case 'IOS_BUNDLE_ID':
            // return 'com.abyssnative.vendor' // vendor
            return 'com.afootinthedoor.work.mobile';
        case 'ANDROID_PACKAGE_NAME':
            // return 'com.abyssnative.vendor' // vendor
            return isTest ? 'com.afootinthedoor.work.mobile' : isStaging || isProd ? 'com.afootinthedoor' : 'com.afootinthedoor';
        case 'DYNAMIC_LINK_URL_SCHEME':
            // return 'com.abyssnative.vendor' // vendor
            return isTest ? 'com.afootinthedoor.work.mobile' : isStaging || isProd ? 'com.afootinthedoor' : 'com.afootinthedoor';
        case 'ELASTICSEARCH_API_URL_PREFIX':
            // 'https://elasticsearch-test02vendor.afootinthedoor.work:8443/abyss/api' // vendor
            // 'https://elasticsearch-dev01.afootinthedoor.work:8443/abyss/api' // dev
            return isTest
                ? 'https://elasticsearch-test01.afootinthedoor.work:8443/abyss/api'
                : isStaging || isProd
                ? 'https://elasticsearch-prod01.afootinthedoor.work/abyss/api'
                : 'https://elasticsearch-test01.afootinthedoor.work:8443/abyss/api';
        case 'STRIPE_API_PUBLISHABLE_KEY':
            return isTest
                ? 'pk_test_51KfpDYGGYnJdvx9wBiKZE3TPYyEcia2bo4e9OxV4IsxboVXvd1oT4Q9Du2XICfQ7Q6Qh7egMahEUDTE1aHCTDYKu00GJS1oxX8'
                : isStaging || isProd
                ? 'pk_live_51KfpDYGGYnJdvx9wuobKsSTHhGAisqFADCD3fFZDDp4HJeo2heX0wnDHWdPUXYXjTvx0xNZWZFTrSigRYyrxoc8V00KFuZtJol'
                : 'pk_test_51KfpDYGGYnJdvx9wBiKZE3TPYyEcia2bo4e9OxV4IsxboVXvd1oT4Q9Du2XICfQ7Q6Qh7egMahEUDTE1aHCTDYKu00GJS1oxX8';
        case 'RECAPTCHA_SITE_KEY':
            // return '6LeVLWYeAAAAANlH4wK-E2KmD8Ilp06POQyyrr1R'; // vendor
            return isTest || isStaging
                ? '6Lf6PRIiAAAAAG0LSDVKYQczPD5SFEa7TmM6A1fA'
                : isProd
                ? '6LdPtxEiAAAAAD2-pGVZqAI3Bm-N4NiG_ZK5MwcD'
                : '6Lf6PRIiAAAAAG0LSDVKYQczPD5SFEa7TmM6A1fA';
        case 'APP_CHECK_RECAPTCHA_SITE_KEY':
            return isTest || isStaging
                ? '6LdiFPgiAAAAAMCxiEOzGWFk8MXsMb-r5yznC-uS'
                : isProd
                ? '6Le_LvgiAAAAAF1LqEnRsi8AaG67ABEYE1XkbDid'
                : '6LdiFPgiAAAAAMCxiEOzGWFk8MXsMb-r5yznC-uS';
        // case 'XXXXXXX':
        //     return isTest ? 'xxxxxx' : isStaging || isProd ? '' : '';
        default:
            return null;
    }
};
